<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']" titleText="i18n.domain.parker-administration.title"></app-title-bar>
<app-wizard-step></app-wizard-step>